<template>
  <div class="header-component" :class="fixedNavigation ? 'bottomMargin' : ''">
    <div class="d-md-none d-lg-block top-product-wrap">
      <Carousel v-if="randomProducts" :products="randomProducts"></Carousel>
    </div>
    <header>
      <div class="logo">
        <a href="/">
          <img src="../assets/logo.png" :alt="siteTitle" />
        </a>
      </div>
      <div :class="fixedNavigation ? 'fixed-top' : ''" style="overflow:hidden">
        <b-navbar type="dark" class="navigation-color">
          <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav class="mx-auto">
              <b-nav-item class="px-5 text-uppercase font-weight-bold" v-for="(menuItem, index) in menuItems" :key="index" :href="index">{{ menuItem }}</b-nav-item>
              <b-nav-item class="px-5" href="/search">
                <i class="fa fa-search"></i>
              </b-nav-item>
            </b-navbar-nav>
          </b-collapse>
        </b-navbar>
      </div>
    </header>
  </div>
</template>

<script>
import axios from "axios";
import Carousel from "./Carousel";
// import VueSlickCarousel from "vue-slick-carousel";
// import "vue-slick-carousel/dist/vue-slick-carousel.css";
// import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

const localStorageKey = "menuItems";

export default {
  name: "DesktopNavigation",
  components: {
    Carousel
  },
  data() {
    return {
      siteTitle: "Dutche Chocolates",
      menuItems: undefined,
      randomProducts: undefined,
      fixedNavigation: false,
    };
  },
  created () {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  mounted() {
    this.getRandomProducts();
    this.showMenuItems();
  },
  methods: {
    handleScroll () {
      if(window.scrollY >= 300) {
        this.fixedNavigation = true;
      } else {
        this.fixedNavigation = false;
      }
    },
    getMenuItems() {
      axios.get("/menu-items").then(response => {
        this.saveMenuItems(response.data);
        this.menuItems = JSON.parse(JSON.stringify(response.data));
      });
    },
    saveMenuItems(value) {
      const now = new Date();
      const timeToLive = 3 * 60 * 60 * 1000; // defaults to 3 hours
      const item = {
        value: value,
        expiration: now.getTime() + timeToLive
      };

      localStorage.setItem(localStorageKey, JSON.stringify(item));
    },

    getSavedMenuItems() {
      const menuItems = localStorage.getItem(localStorageKey);

      if (!menuItems) {
        return null;
      }

      const item = JSON.parse(menuItems);
      const now = new Date();

      if (now.getTime() > item.expiration) {
        localStorage.removeItem(localStorageKey);
        return null;
      }

      return item.value;
    },

    showMenuItems() {
      const menuItems = this.getSavedMenuItems();
      if (menuItems !== null) {
        this.menuItems = menuItems;
      } else {
        this.getMenuItems();
      }
    },

    getRandomProducts() {
      axios.get("/random-products/12").then((response) => {
        this.randomProducts = response.data.randomProducts;
      });
    },
  }
};
</script>

<style lang="sass" scoped>
header
  min-height: 150px
  height: auto
  background-color: $dutche-primary-violet

  .logo
    text-align: center
    padding: 20px 0
    margin-top: -7px

    img
      width: auto
      max-height: 100px

  .navigation-color
    background-color: $dutche-tertiary-violet

  .navbar-dark .navbar-nav .nav-link
    color: #fff
    font-family: "Gotham"

  .navbar-dark .navbar-nav .nav-link:hover
    color: $dutche-primary-violet
</style>
